import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Threads.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const threadFAQs = [
  {
    question: 'How long does a thread lift last?',
    answer: 'Results typically last 12 to 18 months, depending on your skin quality, age, and how your body absorbs the threads.',
  },
  {
    question: 'Is a thread lift painful?',
    answer: 'Local anesthesia is used during the procedure, so most patients feel only mild pressure rather than pain.',
  },
  {
    question: 'How soon can I return to my normal routine?',
    answer: 'Most people resume daily activities within a day or two. Mild swelling or bruising, if any, usually settles within a week.',
  },
  {
    question: 'Who is not a good candidate for thread lifts?',
    answer:
      'Individuals with severe skin sagging may benefit more from a surgical facelift. A consultation helps determine the best option for your skin.',
  },
  {
    question: 'Can thread lifts be combined with other treatments?',
    answer: 'Yes, thread lifts are often combined with fillers or skin boosters for more comprehensive facial rejuvenation.',
  },
]

const Threads = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='threadshero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Threads
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Redefine Your Jawline Without Surgery
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Advanced thread lift technology for tighter, smoother, and lifted skin.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Professional Thread Lift Treatment</h2>
              <p>
                A thread lift is a minimally invasive cosmetic procedure designed to lift and tighten sagging skin. This advanced treatment uses
                dissolvable sutures to stimulate collagen production, giving you a natural and refreshed look without surgery. At Sharva Clinique, we
                combine expertise with a personalized approach to deliver results that enhance your beauty and confidence.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What Is a Thread Lift?</h3>
              <p>
                A thread lift involves inserting medical-grade threads beneath the skin to gently elevate areas like the cheeks, jawline, neck, and
                brows. Once placed, these threads act as a support structure that repositions loose tissue and encourages your body to produce fresh
                collagen. Over time, this new collagen improves skin texture, firmness, and elasticity.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Thread Lift</h3>
              <p>Thread lifts offer several advantages over traditional surgical facelifts:</p>
              <ul>
                <li>Natural-looking lift with minimal downtime</li>
                <li>Quick procedure typically completed within an hour</li>
                <li>Stimulates the skin’s own collagen production</li>
                <li>Results can last up to 12 to 18 months</li>
                <li>Minimal scarring with fast recovery</li>
              </ul>
              <p>
                Whether you want to lift your mid-face, define your jawline, smooth nasolabial folds, or rejuvenate your neck, thread lifting offers a
                subtle but impactful enhancement.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Who Is a Good Candidate?</h3>
              <p>
                Thread lifts are ideal for individuals experiencing mild to moderate skin laxity who want noticeable improvement without undergoing
                invasive surgery. Our clinicians carefully assess your aesthetic goals and skin condition to determine if this treatment is right for
                you.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What to Expect</h3>
              <p>
                Your thread lift begins with a consultation to map treatment areas. Local anesthesia ensures comfort during the procedure. After
                placement, most clients return to regular activities within a day or two, with mild swelling or bruising that fades quickly.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Why Choose Us</h3>
              <p>
                At Sharva Clinique, our skilled professionals prioritize safety and natural results. We use the latest thread technologies and tailor
                every treatment plan to your unique features.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb='Dr. Sweta Mishra performs thread lift procedures at Sharva Clinique, combining surgical precision with an aesthetic eye for natural-looking facial rejuvenation.'
              profileLink='/drSweta/thread'
            />

            <ServiceFAQ title='FAQs - Thread Lift Treatment' faqs={threadFAQs} />
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>
                “The procedure was smooth and pain was very minimal. I’m only a few weeks in and already see a big difference. Couldn’t be happier
                with the results!”
              </p>
              <p> — Arjun </p>
            </div>
            <div className='card2'>
              <p>
                “The doctor was very gentle and explained every step. Mild swelling for a couple of days, but the lift was visible immediately.
                Totally worth it.”
              </p>
              <p> — Manish </p>
            </div>
            <div className='card3'>
              <p>
                “I was back to my daily routine very quickly. There was minimal discomfort and the results kept improving over the next few weeks.”
              </p>
              <p> — Anusha </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Threads
